import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import URLstateContext from "../../../provider/CommonContext";
import CompanyAbout from './../CompanyAbout/CompanyAbout';
import { Rings } from 'react-loader-spinner';
import { Vortex } from 'react-loader-spinner'

function CompanyChartFandO(props, ref) {
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  let getExchange = props.exchange;
  let getCoCode = props.coCode;
  let getSymbol = props.symbolFandO;
  let getExpiryOpt = props.expiryDate;
  let getOption = props.optionType;
  let getStrikePrice = props.strikePrice;
  let getInstr = props.valueInstr;
  let getInstrValue = props.instrText;
  let getexpiryDateFut = props.expiryDateFut;
  let getInstrument_value = props.valueInstrument;
  let getValueExpDate = props.valueExpDateFinal;
  const [data, setData] = useState([]);
  const [dataF, setDataF] = useState([]);
  const [dataFinal, setDataFinal] = useState([]);
  const [chartdata, setchartData] = useState([]);
  let getData, getchartData, indicator, getDataFandO;
  const [chartperiod, setchartperiod] = useState('1D');



  useEffect(() => {
    if (getValueExpDate != '' && getSymbol != '') {
      const getUrlExpiryFut = BaseURL + "GetQuoteDerivativesFandO";
      fetch(`${getUrlExpiryFut}/GQ/${getValueExpDate}/futstk/${getSymbol}/-/-`)
        .then((response) => response.json())
        .then((data) => {
          getDataFandO = data.data;
          setData(getDataFandO);
          //console.log(data);
        })
        .catch((error) => {
          // console.log("not found te api 1233333");
        });
      const getUrlchartFut = BaseURL + "FandOChart";
      fetch(`${getUrlchartFut}/futstk/${getSymbol}/${getValueExpDate}/0/XX`)
        .then((response) => response.json())
        .then((data) => {
          getchartData = data.data;
          setchartData(getchartData);
          // console.log("chartdata:", getchartData);
          //console.log("chartdata:"+JSON.stringify(getchartData));
        })
        .catch((error) => {
          // console.log("not found the api");
        });
    }
  }, [props.valueExpDateFinal, props.symbolFandO]);

  useLayoutEffect(() => {
    let root = am5.Root.new("chartdivFandO");

    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    let chart = root.container.children.push(am5xy.XYChart.new(root, {
      panY: false,

      layout: root.verticalLayout
    }));

    indicator = root.container.children.push(am5.Container.new(root, {
      width: am5.p100,
      height: am5.p100,
      layer: 1000,
      background: am5.Rectangle.new(root, {
        fill: am5.color(0xffffff),
        fillOpacity: 0.7
      })
    }));

    indicator.children.push(am5.Label.new(root, {
      text: "Loading...",
      fontSize: 25,
      x: am5.p50,
      y: am5.p50,
      centerX: am5.p50,
      centerY: am5.p50
    }));


    chart.get("colors").set("colors", [
      am5.color(0x024FA1),

    ]);

    // Create Y-axis
    let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
      maxDeviation: 1,
      renderer: am5xy.AxisRendererY.new(root, {})
    }));

    // Create X-Axis
    let baseI = chartperiod === "1D" ? { timeUnit: "minute", count: 1 } : { timeUnit: "day", count: 1 };


    var xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
    xRenderer.labels.template.setAll({
      rotation: -60,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15
    });
    let xAxis = chart.xAxes.push(am5xy.DateAxis.new(root, {
      //groupData: true,
      maxDeviation: 0.5,
      renderer: xRenderer,
      baseInterval: baseI,

    }));

    function generateChartData() {

      let chartData = [];

      if (chartdata != null && chartdata != []) {
        for (var i = 0; i < chartdata.length; i++) {
          let newDate = new Date(chartdata[i].UpdTime);


          chartData.push({
            time: newDate.getTime(),
            price: chartdata[i].LTP
          });
        }
      }
      else {

      }
      return chartData;


    }

    // console.log("ddddd:"+JSON.stringify(generateChartData()));
    let data = generateChartData();



    //let lbltxt = "[bold]{name}[/]\n{valueX.formatDate()}: {valueY}";

    let lbltxt = chartperiod === "1D" ? "[bold] ₹ {valueY} | {valueX.formatDate('HH:mm')}" : "[bold] ₹ {valueY} | {valueX.formatDate('dd-MMM-yyyy')}";

    // Create series
    let series = chart.series.push(am5xy.LineSeries.new(root, {
      name: "Series",
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "price",
      valueXField: "time",
      tooltip: am5.Tooltip.new(root, {
        pointerOrientation: "horizontal",
        labelText: lbltxt
      })
    }));

    series.strokes.template.set("strokeWidth", 2);
    series.fills.template.setAll({
      visible: true,
      fillOpacity: 0.4
    });
    if (chartperiod === "1D" || chartperiod === "5D") {
      series.bullets.push(function (root) {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 3,
            fill: series.get("fill"),
            fill: am5.color(0x024FA1),
          })
        });
      });
    }

    series.set("fill", am5.color(0x80D962)); // set Series color to red



    series.data.setAll(data);



    series.fills.template.set("fillGradient", am5.LinearGradient.new(root, {
      stops: [{
        opacity: 0
      }, {
        opacity: 1
      }],
      rotation: 90
    }));

    // Add cursor
    chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "none",
      xAxis: xAxis
    }));

    xAxis.set("tooltip", am5.Tooltip.new(root, {}));

    yAxis.set("tooltip", am5.Tooltip.new(root, {}));
    indicator.hide();

    return () => {
      root.dispose();
    };
  }, [chartdata]);


  useEffect(() => {
    if (getexpiryDateFut != null && getSymbol != null) {
      if (getInstr === "futures") {
        const getUrlExpiryFut = BaseURL + "GetQuoteDerivativesFandO";
        fetch(`${getUrlExpiryFut}/GQ/${getexpiryDateFut}/futstk/${getSymbol}/-/-`)
          .then((response) => response.json())
          .then((data) => {
            getDataFandO = data.data;
            setData(getDataFandO);
            // console.log(data);
          })
          .catch((error) => {
            // console.log("not found te api 1233333");
          });
        const getUrlchartFut = BaseURL + "FandOChart";
        fetch(`${getUrlchartFut}/futstk/${getSymbol}/${getexpiryDateFut}/0/XX`)
          .then((response) => response.json())
          .then((data) => {
            getchartData = data.data;
            setchartData(getchartData);
            // console.log("chartdata:", getchartData);
            // console.log("chartdata:"+JSON.stringify(getchartData));
          })
          .catch((error) => {
            // console.log("not found the api");
          });
      }
    }
    if (getInstr === "options") {
      const getUrlExpiry = BaseURL + "GetQuoteDerivativesFandO";
      fetch(`${getUrlExpiry}/GQ/${getExpiryOpt}/OPTSTK/${getSymbol}/${getOption}/${getStrikePrice}`)
        .then((response) => response.json())
        .then((data) => {
          getDataFandO = data.data;
          setData(getDataFandO);
          //console.log(data);
        })
        .catch((error) => {
          //console.log("not found te api 1233333");
        });

      const getUrlchart = BaseURL + "FandOChart";
      fetch(`${getUrlchart}/optstk/${getSymbol}/${getExpiryOpt}/${getStrikePrice}/${getOption}`)
        .then((response) => response.json())
        .then((data) => {
          getchartData = data.data;
          setchartData(getchartData);
          // console.log("chartdata:", getchartData);
          //console.log("chartdata:"+JSON.stringify(getchartData));
        })
        .catch((error) => {
          // console.log("not found the api");
        });
    }
  }, [props.expiryDate, props.optionType, props.strikePrice, props.symbolFandO, props.expiryDateFut]);


  return (
    <>
      <section className="company-chart-section compChart">
        <Container className="add-border table-box1">
          <Row>
            <Col md={12} lg={5}>
              <div className="company-chart-data ">
              {(data === null) ? <div className="errorDiv"><h4 className="errormsgComNew">No Data Available !!!</h4></div> : ''}
                {getInstr === "futures" && data != null && data.map((eachData) => (
                  <ul>
                    <li>
                      <span>Open</span>
                      <h4> {(eachData.OpenPrice != null) ? eachData.OpenPrice.toFixed(2) : eachData.OpenPrice = 0}</h4>
                    </li>
                    <li>
                      <span>Price</span>
                      <h4> {(eachData.LTP != null) ? eachData.LTP.toFixed(2) : eachData.LTP = 0}</h4>
                    </li>
                    <li>
                      <span>Average Trade Price</span>
                      <h4> {(eachData.AvgTP != null) ? eachData.AvgTP.toFixed(2) : eachData.AvgTP = 0}</h4>
                    </li>
                    <li>
                      <span>Today's high</span>
                      <h4> {
                        (eachData.HighPrice != null) ? eachData.HighPrice.toFixed(2) : eachData.HighPrice = 0
                      }</h4>
                    </li>
                    <li>
                      <span>Buy Value</span>
                      <h4> {(eachData.BBuyPrice != null) ? eachData.BBuyPrice.toFixed(2) : eachData.BBuyPrice = 0}</h4>
                    </li>
                    <li>
                      <span>Prev. Close</span>
                      <h4> {
                        (eachData.PrevLtp != null) ? eachData.PrevLtp.toFixed(2) : eachData.PrevLtp = 0
                      }</h4>
                    </li>
                    <li>
                      <span>Market Lot</span>
                      <h4> {(eachData.MktLot != null) ? eachData.MktLot : eachData.MktLot = 0}</h4>
                    </li>
                    <li>
                      <span>Change in OI (%)</span>
                      <h4> {(eachData.chgOpenInt != null) ? eachData.chgOpenInt.toFixed(2) : eachData.chgOpenInt = 0}</h4>
                    </li>
                    <li>
                      <span>Today's low</span>
                      <h4> {(eachData.LowPrice != null) ? eachData.LowPrice.toFixed(2) : eachData.LowPrice = 0}</h4>
                    </li>
                    <li>
                      <span>Sell Value</span>
                      <h4> {(eachData.BSellPrice != null) ? eachData.BSellPrice.toFixed(2) : eachData.BSellPrice = 0}</h4>
                    </li>
                    <li>
                      <span>Turnover</span>
                      <h4> {(eachData.Turnover != null) ? eachData.Turnover.toFixed(2) : eachData.Turnover = 0}</h4>
                    </li>
                  </ul>
                ))}
                {getInstr === "options" && data != null && data.map((eachData) => (
                  <ul>
                    <li>
                      <span>Open</span>
                      <h4> {(eachData.OpenPrice != null) ? eachData.OpenPrice.toFixed(2) : eachData.OpenPrice = 0}</h4>
                    </li>
                    <li>
                      <span>Price</span>
                      <h4> {(eachData.LTP != null) ? eachData.LTP.toFixed(2) : eachData.LTP = 0}</h4>
                    </li>
                    <li>
                      <span>Average Trade Price</span>
                      <h4> {(eachData.AvgTP != null) ? eachData.AvgTP.toFixed(2) : eachData.AvgTP = 0}</h4>
                    </li>
                    <li>
                      <span>Today's high</span>
                      <h4> {
                        (eachData.HighPrice != null) ? eachData.HighPrice.toFixed(2) : eachData.HighPrice = 0
                      }</h4>
                    </li>
                    <li>
                      <span>Buy Value</span>
                      <h4> {(eachData.BBuyPrice != null) ? eachData.BBuyPrice.toFixed(2) : eachData.BBuyPrice = 0}</h4>
                    </li>
                    <li>
                      <span>Prev. Close</span>
                      <h4> {
                        (eachData.PrevLtp != null) ? eachData.PrevLtp.toFixed(2) : eachData.PrevLtp = 0
                      }</h4>
                    </li>
                    <li>
                      <span>Market Lot</span>
                      <h4> {(eachData.MktLot != null) ? eachData.MktLot : eachData.MktLot = 0}</h4>
                    </li>
                    <li>
                      <span>Change in OI (%)</span>
                      <h4> {(eachData.chgOpenInt != null) ? eachData.chgOpenInt.toFixed(2) : eachData.chgOpenInt = 0}</h4>
                    </li>
                    <li>
                      <span>Today's low</span>
                      <h4> {(eachData.LowPrice != null) ? eachData.LowPrice.toFixed(2) : eachData.LowPrice = 0}</h4>
                    </li>
                    <li>
                      <span>Sell Value</span>
                      <h4> {(eachData.BSellPrice != null) ? eachData.BSellPrice.toFixed(2) : eachData.BSellPrice = 0}</h4>
                    </li>
                    <li>
                      <span>Turnover</span>
                      <h4> {(eachData.Turnover != null) ? eachData.Turnover.toFixed(2) : eachData.Turnover = 0}</h4>
                    </li>
                  </ul>
                ))}
              </div>
            </Col>
            <Col md={12} lg={7}>
              <CompanyAbout exchange={getExchange} coCode={getCoCode} />
            </Col>

          </Row>
        </Container>
        <Container className="table-box">
          <Row>
            <Col md={12}>
            {(data === null) ? <div className="errorDiv"><h4 className="errormsgComNew">No Data Available !!!</h4></div> : ''}
              <div id="chartdivFandO" style={{ width: "100%", height: "325px" }}></div>

            </Col>
          </Row>
        </Container>

      </section>
    </>
  );
}

export default React.forwardRef(CompanyChartFandO);
